<template>
  <div class="irp-open-opportunities-header">
    <span class="ag-header-cell-text irp-open-opportunities-header__text">{{
      params.displayName
    }}</span>
    <BittsTooltip
      class="irp-open-opportunities-header__tooltip"
      placement="top"
      :mount-to-body="true"
      overlay-class="max-w-[240px] text-left"
    >
      <button
        type="button"
        class="irp-open-opportunities-header__info"
        :aria-label="DESCRIPTION"
        data-testid="irp-open-opportunities-info"
      >
        <FontAwesomeIcon
          :icon="['fak', 'information-circle']"
          class="irp-open-opportunities-header__icon"
        />
      </button>
      <template #title>{{ DESCRIPTION }}</template>
    </BittsTooltip>
  </div>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

const { params } = defineProps<{
  params: { displayName: string };
}>();

const DESCRIPTION =
  'Open opportunities this partner is sharing with you for this account.';
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-open-opportunities-header {
  @apply flex min-w-0 items-center gap-4;
}

.irp-open-opportunities-header__text {
  @apply truncate;
}

.irp-open-opportunities-header__tooltip {
  @apply shrink-0;
}

.irp-open-opportunities-header__info {
  @apply flex shrink-0 items-center appearance-none border-0 bg-transparent p-0 cursor-default;
}

.irp-open-opportunities-header__info:focus-visible {
  @apply outline-2 outline-offset-2 outline-neutral-border-focus rounded-4;
}

.irp-open-opportunities-header__icon {
  @apply h-12 w-12 text-neutral-accent;
}
</style>
